var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"暂无数据","image":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }